import apiFetch from '../apiFetch'

export default function (token, processingAgencyId, communicationServiceId) {
  return apiFetch({ endPoint: 'ProcessingAgency/' + processingAgencyId + '/communicationService/' + communicationServiceId, method: 'PUT', body: null, token: token })
}
